export const dynamicPagesApiHandler = {
  getOrganizationPages: {
    method: "GET",
    path: () => `org-dynamic-pages-management/all-pages`
  }
};